import {Record} from 'immutable';

export default class CrmStage extends Record({
  id: null,
  crmDataId: null,
  crmId: null,
  clientName: null,
  clientOrder: null,
  evStage: null,
  crmName: null,
}) {}
